// The full gate for auto-saving a comment-derived justification, as plain booleans so it can be unit
// tested without mounting. All conditions must hold: the host changed this task in-session, the task is
// editable and tailored (and not a header), the change has settled, a comment is anchored to it, no
// justification exists yet, and we haven't already saved one for this task.
export function shouldAutoSaveCommentJustification({
    sawInSessionChange,
    isEditable,
    pendingChange,
    taskTailored,
    isHeader,
    hasComment,
    hasExistingReason,
    alreadySaved,
}) {
    return (
        sawInSessionChange &&
        isEditable &&
        !pendingChange &&
        taskTailored &&
        !isHeader &&
        hasComment &&
        !hasExistingReason &&
        !alreadySaved
    )
}
